import NetworkIcon from '@assets/images/network-exposures.svg?react'
import PaperIcon from '@assets/images/paper.svg?react'
import PointedShieldIcon from '@assets/images/pointed-shield.svg?react'
import { AssociatedIssuesTable } from '@ui/drawer/common/AssociatedIssuesTable'
import { AssociatedTechnologiesTable } from '@ui/drawer/common/AssociatedTechnologiesTable'
import { SectionHeader } from '@ui/drawer/common/SectionHeader'

import {
    Body,
    DetailsSection,
    IssuesSection,
    IssuesTableHost,
    SectionDivider,
    TechnologiesSection,
    Wrapper,
} from './assetDetails.styles'
import { AssetCloudAppInfo } from './assetCloudAppInfo'
import { AssetDeviceInfo } from './assetDeviceInfo'
import { AssetInfo } from './assetInfo'
import { AssetInfoDomainDetails } from './assetInfoDomainDetails'
import AssetUserInfo from './assetUserInfo/assetUserInfo'
import { useAssetDetails } from './useAssetDetails'

const DOMAIN_DRAWER_ASSET_TYPES: TAssetType[] = ['domain', 'subdomain']
const USER_ISSUES_MAX_VISIBLE_ROWS = 8

const AssetDetails = () => {
    const { currentAsset, assetType, enrichedAssetIssues, fullTechnologies } =
        useAssetDetails()

    if (!currentAsset) return null

    const isDomainAsset = assetType
        ? DOMAIN_DRAWER_ASSET_TYPES.includes(assetType)
        : false

    const renderAssetInfo = () => {
        if (isDomainAsset) {
            return <AssetInfoDomainDetails asset={currentAsset} />
        }
        switch (assetType) {
            case 'device':
                return <AssetDeviceInfo asset={currentAsset} />
            case 'user':
                return <AssetUserInfo asset={currentAsset} />
            case 'cloud_app':
                return <AssetCloudAppInfo asset={currentAsset} />
            default:
                return <AssetInfo asset={currentAsset} />
        }
    }

    return (
        <Wrapper>
            <Body>
                <DetailsSection>
                    <SectionHeader
                        icon={<PaperIcon />}
                        title="Details"
                        dataTestId="details-section"
                    />
                    {renderAssetInfo()}
                </DetailsSection>
                {isDomainAsset && (
                    <>
                        <SectionDivider />
                        <TechnologiesSection>
                            <SectionHeader
                                icon={<NetworkIcon />}
                                title="Technologies"
                                count={fullTechnologies.length}
                                dataTestId="associated-technologies-section"
                            />
                            <AssociatedTechnologiesTable
                                technologies={fullTechnologies}
                                dataTestId="associated-technologies-table"
                                origin="asset-drawer"
                            />
                        </TechnologiesSection>
                    </>
                )}
                <SectionDivider />
                <IssuesSection>
                    <SectionHeader
                        icon={<PointedShieldIcon />}
                        title="Open issues"
                        count={enrichedAssetIssues.length}
                        dataTestId="associated-issues-section"
                    />
                    <IssuesTableHost>
                        <AssociatedIssuesTable
                            key={currentAsset.id}
                            issues={enrichedAssetIssues}
                            dataTestId="associated-issues-table"
                            origin="asset-drawer"
                        />
                    </IssuesTableHost>
                </IssuesSection>
            </Body>
        </Wrapper>
    )
}

export default AssetDetails
